// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__38UgS","questions":"styles_questions__1wCXM","footer":"styles_footer__2NojY"};